import { NewsBannerType } from 'types/newsbanner';

export const newsBanners = [
    {
      active: true,
      hidden: false,
      id: 'refer',
      image: 'refer.png',
      heading: {
        en: 'Earn and Give Cash Rewards',
        de: ''
      },
      subHeading: {
        en: 'By Referring Friends',
        de: ''
      },
      link: '/rewards',
      imageClassName: 'w-[110px] h-[90px] lg:w-[185px] lg:h-[185px] justify-end -mb-4 -mt-2 -mr-2 -mb-4 -mt-2 lg:-mr-3',
      titleClassName: 'text-3xl lg:text-6xl leading-5 lg:leading-9',
      subtitletitleClassName: 'text-2xl lg:text-4xl'
    }
  ] as NewsBannerType[];